export default __webpack_public_path__ + "static/media/soccerPlayerDefault.e01f391e.png";